module.exports = __webpack_public_path__ + "8ad2c97bb5793b4ca409bda486a8fdc0.png";